import styled from 'styled-components';

import LoadingPage from '../LoadingPage';
import SearchBar from '../../chat/components/SearchBar';
import colors from '../../styles/colors';

const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 300px;
  background-color: ${colors.shades.secondary5};
`;

const SearchFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px 4px 4px;
  background-color: ${colors.shades.secondary10};
  border-bottom: 1px solid ${colors.shades.secondary7};
`;

const FilterTabs = styled.div`
  display: flex;
  gap: 6px;
`;

const FilterTab = styled.button`
  padding: 5px 14px;
  border-radius: 20px;
  border: 1.5px solid ${({ $active }) => ($active ? colors.base.secondary2 : colors.shades.secondary7)};
  background-color: ${({ $active }) => ($active ? colors.base.secondary2 : 'transparent')};
  color: ${({ $active }) => ($active ? colors.base.alpha : colors.base.secondary2)};
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;

  &:hover {
    background-color: ${({ $active }) => ($active ? colors.base.secondary2 : colors.shades.secondary7)};
  }
`;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid ${colors.shades.secondary7};
  background-color: ${colors.shades.secondary10};
`;

const TableHeaderCell = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${colors.shades.gamma10};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  flex-shrink: 0;

  &.name { flex: 1; padding-left: 60px; }
  &.uploaded { width: 120px; }
  &.menu { width: 36px; }
`;

const DocumentList = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
`;

const MonthGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const MonthHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 6px;
`;

const MonthLabel = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.base.secondary2};
`;

const MonthCount = styled.span`
  font-size: 12px;
  color: ${colors.shades.gamma10};
`;

const EmptyState = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: ${colors.shades.gamma10};
  font-size: 14px;
  padding: 48px 32px;
  text-align: center;
`;

const PanelLoadingPage = styled(LoadingPage)`
  height: 300px;
`;

const PanelSearchBar = styled(SearchBar)`
  .MuiOutlinedInput-root {
    height: 34px;
  }
`;

const LoadMoreRow = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 12px 16px;
`;

export {
  PanelContainer,
  SearchFilterRow,
  FilterTabs,
  FilterTab,
  TableHeader,
  TableHeaderCell,
  DocumentList,
  MonthGroup,
  MonthHeader,
  MonthLabel,
  MonthCount,
  EmptyState,
  LoadMoreRow,
  PanelLoadingPage,
  PanelSearchBar,
};
